export class EconomicSector {
  id: number;
  name: string;
  active: boolean;
  translationKey: string;
}

export enum EconomicSectorId {
  CONSORTIA_ADMINISTRATOR = 2000,
  CLUB_RECREATION = 2001,
  EDUCATION = 2002,
  COLLECTIONS_COMPANY = 2003,
  REAL_ESTATE = 2004,
  OTHER_ACTIVITY = 2005,
  HEALTH_SERVICES = 2006,
  FINANCIAL_SERVICES = 2007,
  PROFESSIONAL_SERVICES = 2008,
  TELECOMMUNICATIONS = 2009,
  DIRECT_SELLING = 2010,
  GENERAL_GOODS_SERVICES = 2011,
  INSURANCES = 2012,
  UTILITIES = 2013
}

